module.exports = __webpack_public_path__ + "img/address.e301eaad.svg";